import HasClassList from "../interface/HasClassList";

export default abstract class DOMController implements HasClassList
{
    protected classes = {};

    public setClassToken(token: string, value: string)
    {
        if (token in this.classes) {
            this.classes[token] = value;
        }
    }

    public getClassByToken(token: string): string|null
    {
        if (token in this.classes) {
            return this.classes[token];
        }

        return null;
    }

    public getHTMLSelectorByClassToken(token: string): string
    {
        if (token in this.classes) {
            return '.' + this.classes[token];
        }

        throw new Error('Class with token "' + token + '" not found in ' + this.constructor.name);
    }
}
